<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>永續專區ESG</h2>
            <h2 style="padding-top: 10px;">S社會參與</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="about-area pt-50 pb-20">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd; text-align: center;">ESG課程</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>
<!-- End About Area -->

<!-- Start Features Area -->
<section class="features-area esg-class">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <img src="assets/img/esg/1121127.png" alt="image" class="image">
            <div class="content">
                <!-- <h3 class="title">共能碩力</h3> -->
                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> ISO 14064-1組織型溫室氣體盤查簡介</span></li>
                    <li><span><i class='bx bx-check-double'></i> ISO 14067產品碳足跡簡介</span></li>
                    <li><span><i class='bx bx-check-double'></i> ISO 14051 MFCA物質流成本會計簡介</span></li>
                    <li><span><i class='bx bx-check-double'></i> 永續報告書撰寫概述</span></li>
                    <!-- <li><span><i class='bx bx-check-double'></i> 旗艦級專案導入</span></li> -->
                </ul>
            </div>
        </div>

        <div class="overview-box">
            <img src="assets/img/esg/1121211.png" alt="image" class="image">
            <div class="content">
                <!-- <h3 class="title">共能碩力</h3> -->
                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> 淨零轉型政策</span></li>
                    <li><span><i class='bx bx-check-double'></i> 淨零轉型治理</span></li>
                    <li><span><i class='bx bx-check-double'></i> 永續供應鏈管理</span></li>
                    <!-- <li><span><i class='bx bx-check-double'></i> 企業轉型諮詢</span></li>
                    <li><span><i class='bx bx-check-double'></i> 旗艦級專案導入</span></li> -->
                </ul>
            </div>
        </div>

        <div class="overview-box">
            <img src="assets/img/esg/1121225.png" alt="image" class="image">
            <div class="content">
                <!-- <h3 class="title">共能碩力</h3> -->
                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> 國際趨勢之永續意涵</span></li>
                    <li><span><i class='bx bx-check-double'></i> ESG，碳管理</span></li>
                    <li><span><i class='bx bx-check-double'></i> 生命週期設計</span></li>
                    <li><span><i class='bx bx-check-double'></i> 國際趨勢之永續意涵</span></li>
                    <!-- <li><span><i class='bx bx-check-double'></i> 旗艦級專案導入</span></li> -->
                </ul>
            </div>
        </div>

        <div class="overview-box">
            <img src="assets/img/esg/1130415.png" alt="image" class="image">
            <div class="content">
                <!-- <h3 class="title">共能碩力</h3> -->
                <ul class="features-list">
                    <li><span><i class='bx bx-check-double'></i> ESG 淨零新經濟崛起</span></li>
                    <li><span><i class='bx bx-check-double'></i> 氣候評比要點與低碳供應鏈行動</span></li>
                    <li><span><i class='bx bx-check-double'></i> 關鍵行動-SBTi 科學基礎減量目標設定</span></li>
                    <li><span><i class='bx bx-check-double'></i> 淨零實踐標竿案例解析</span></li>
                    <li><span><i class='bx bx-check-double'></i> 企業淨零轉型關鍵步驟</span></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- End Features Area -->

<section class="about-area pt-50 pb-20">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd; text-align: center;">相關活動</h3>
            </div>
        </div>
    </div>
</section>


<section class="team-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div> -->
            <img src="assets/img/esg/淡水.png" class="image" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">淡水八里一日遊</h3>
                <p style="font-size: 18px;color: black;">
                    淡水八里左岸的一日遊中，我們享受美景的同時，也重申了對環境、社會及治理責任的承諾。這次活動讓我們更深入地了解生態保護的重要性，並決心在公司運營中推動環保措施，減少碳足跡，推廣可持續發展。我們也強調了社會責任，將持續關注社區發展，積極參與公益活動。良好的治理是我們實現這些目標的基石，我們將堅持透明、誠信和負責任的經營理念，為環境和社會帶來積極影響。這次淡水八里左岸之行，不僅放鬆了身心，更在ESG道路上邁出了堅實的一步，共創美好未來。
                </p>
            </div>
        </div>
    </div>
</section>

<section class="team-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div> -->
            <img src="assets/img/esg/登山.png" class="image" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">校友登山活動</h3>
                <p style="font-size: 18px;color: black;">
                    與台北商業大學師生共同參加了一次意義深遠的登山健行活動。這次活動讓我們親身感受了自然之美，並深化了我們對環境、社會及治理的承諾。在登山過程中，我們更加堅定了保護環境的決心，致力於推動可持續發展，減少碳排放。我們也加強了對社會責任的承擔，支持教育和公益，促進社會福祉。我們始終堅持透明和誠信的經營理念，確保在穩健發展的同時，對環境和社會產生積極影響。這次活動不僅是一場愉快的經歷，也是我們在ESG道路上邁出的重要一步。
                </p>
            </div>
        </div>
    </div>
</section>

<section class="team-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;">
            <!-- <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div> -->
            <img src="assets/img/esg/2023.png" class="image" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">2023四校聯盟程式設計競賽</h3>
                <p style="font-size: 18px;color: black;">
                    2023年四校聯盟程式設計競賽不僅促進了技術交流，還體現了企業社會責任和環境、社會及公司治理的理念。由台北商業大學、東吳大學、台北科技大學和台北市立大學共同參與，旨在促進各校學生之間的技術交流與合作。比賽內容涵蓋多個程式設計挑戰，測試參賽者的編程能力和問題解決技巧。競賽期間，各校隊伍展現了高度的技術水平和團隊合作精神，積極應對各種題目。最終，各校隊伍都取得了優異的成績，展現了學生們在程式設計領域的卓越素質。本次競賽為參賽者提供了一個展示實力和互相學習的良好平台。
                </p>
            </div>
        </div>
    </div>
</section>

<!-- <section class="team-area">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box" style="justify-content: space-evenly;">
            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/img/about/pic_05.jpg" alt="image" style="max-width: 60%;">
            </div>
            <img src="assets/img/esg/2024.png" class="pic5" alt="image">

            <div class="content">
                <h3 style="color: #2781bd;">2024北區七校聯盟程式設計競賽</h3>
                <p style="font-size: 18px;color: black;">
                    與台北商業大學師生共同參加了一次意義深遠的登山健行活動。這次活動讓我們親身感受了自然之美，並深化了我們對環境、社會及治理（ESG）的承諾。在登山過程中，我們更加堅定了保護環境的決心，致力於推動可持續發展，減少碳排放。我們也加強了對社會責任的承擔，支持教育和公益，促進社會福祉。我們始終堅持透明和誠信的經營理念，確保在穩健發展的同時，對環境和社會產生積極影響。這次活動不僅是一場愉快的經歷，也是我們在ESG道路上邁出的重要一步。
                </p>
            </div>
        </div>
    </div>
</section> -->
<!-- <app-subscribe></app-subscribe> -->